import { withErrorBoundary, useErrorBoundary } from 'react-use-error-boundary';

const ErrorBoundary = withErrorBoundary(({ children }) => {
	const [error, resetError] = useErrorBoundary((error, errorInfo) => console.log(error, errorInfo));

	if (error) {
		return (
			<div>
				<h2>An Error Has Occurred</h2>
				<details>{error && error.toString()}</details>
			</div>
		);
	}

	return children;
});

export default ErrorBoundary;
